<app-side-menu>
  <div class="service-form-content">
    <div class="page-header">
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <button type="button" class="btn btn-outline-secondary me-3" (click)="cancel()">
            <i class="fas fa-arrow-left me-2"></i>
            Voltar
          </button>
          <div>
            <h1 class="page-title">
              <i class="fas fa-wrench me-3"></i>
              {{ isEditMode ? 'Editar' : 'Novo' }} Tipo de Serviço
            </h1>
          </div>
        </div>
      </div>
    </div>

  <!-- Loading -->
  <div *ngIf="loading && isEditMode" class="loading-container">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Carregando...</span>
    </div>
    <p>Carregando dados do serviço...</p>
  </div>

  <!-- Error -->
  <div *ngIf="error" class="alert alert-danger alert-dismissible fade show" role="alert">
    <i class="fas fa-exclamation-triangle"></i> {{ error }}
    <button type="button" class="close" (click)="error = null">
      <span>&times;</span>
    </button>
  </div>

  <!-- Formulário -->
  <form [formGroup]="form" (ngSubmit)="onSubmit()" *ngIf="!loading">
    <div class="row">
      <!-- Coluna Esquerda -->
      <div class="col-md-8">
        <div class="form-card">
          <h4>Informações Básicas</h4>

          <!-- Nome -->
          <div class="form-group">
            <label for="name">
              Nome do Serviço <span class="required">*</span>
            </label>
            <input 
              type="text" 
              id="name" 
              formControlName="name" 
              class="form-control"
              [class.is-invalid]="name?.invalid && (name?.touched || submitted)"
              placeholder="Ex: Troca de óleo">
            <div class="invalid-feedback" *ngIf="name?.invalid && (name?.touched || submitted)">
              <div *ngIf="name?.errors?.['required']">Nome é obrigatório</div>
              <div *ngIf="name?.errors?.['maxlength']">Nome deve ter no máximo 200 caracteres</div>
            </div>
          </div>

          <!-- Descrição -->
          <div class="form-group">
            <label for="description">Descrição</label>
            <textarea 
              id="description" 
              formControlName="description" 
              class="form-control" 
              rows="4"
              [class.is-invalid]="description?.invalid && (description?.touched || submitted)"
              placeholder="Descreva o serviço em detalhes..."></textarea>
            <small class="form-text text-muted">
              {{ (description?.value?.length || 0) }}/1000 caracteres
            </small>
            <div class="invalid-feedback" *ngIf="description?.invalid && (description?.touched || submitted)">
              <div *ngIf="description?.errors?.['maxlength']">Descrição deve ter no máximo 1000 caracteres</div>
            </div>
          </div>

          <!-- Código e Categoria -->
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="code">Código</label>
                <input 
                  type="text" 
                  id="code" 
                  formControlName="code" 
                  class="form-control"
                  [class.is-invalid]="code?.invalid && (code?.touched || submitted)"
                  placeholder="Ex: SRV-001">
                <small class="form-text text-muted">
                  Código único para identificação interna
                </small>
                <div class="invalid-feedback" *ngIf="code?.invalid && (code?.touched || submitted)">
                  <div *ngIf="code?.errors?.['maxlength']">Código deve ter no máximo 50 caracteres</div>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label for="category">Categoria</label>
                <select 
                  id="category" 
                  formControlName="category" 
                  class="form-control">
                  <option value="">Selecione uma categoria...</option>
                  <option *ngFor="let cat of categories" [value]="cat.value">{{ cat.label }}</option>
                </select>
              </div>
            </div>
          </div>

          <!-- Tempo Estimado -->
          <div class="form-group">
            <label for="estimatedTimeMinutes">Tempo Estimado (minutos)</label>
            <input 
              type="number" 
              id="estimatedTimeMinutes" 
              formControlName="estimatedTimeMinutes" 
              class="form-control"
              [class.is-invalid]="estimatedTimeMinutes?.invalid && (estimatedTimeMinutes?.touched || submitted)"
              min="0"
              placeholder="Ex: 60">
            <small class="form-text text-muted">
              Tempo estimado: {{ formatTimePreview() }}
            </small>
            <div class="invalid-feedback" *ngIf="estimatedTimeMinutes?.invalid && (estimatedTimeMinutes?.touched || submitted)">
              <div *ngIf="estimatedTimeMinutes?.errors?.['min']">Tempo deve ser maior ou igual a 0</div>
            </div>
          </div>
        </div>

        <!-- Custos e Precificação -->
        <div class="form-card">
          <h4>Custos e Precificação</h4>

          <div class="row">
            <!-- Custo Base -->
            <div class="col-md-4">
              <div class="form-group">
                <label for="baseCost">Custo Base (R$)</label>
                <input 
                  type="number" 
                  id="baseCost" 
                  formControlName="baseCost" 
                  class="form-control"
                  [class.is-invalid]="baseCost?.invalid && (baseCost?.touched || submitted)"
                  step="0.01"
                  min="0"
                  placeholder="0.00">
                <small class="form-text text-muted">
                  Custo inicial do serviço
                </small>
                <div class="invalid-feedback" *ngIf="baseCost?.invalid && (baseCost?.touched || submitted)">
                  <div *ngIf="baseCost?.errors?.['min']">Custo deve ser maior ou igual a 0</div>
                </div>
              </div>
            </div>

            <!-- Custo Atual -->
            <div class="col-md-4">
              <div class="form-group">
                <label for="currentCost">Custo Atual (R$)</label>
                <input 
                  type="number" 
                  id="currentCost" 
                  formControlName="currentCost" 
                  class="form-control"
                  [class.is-invalid]="currentCost?.invalid && (currentCost?.touched || submitted)"
                  step="0.01"
                  min="0"
                  placeholder="0.00">
                <small class="form-text text-muted">
                  Custo atual considerando reajustes
                </small>
                <div class="invalid-feedback" *ngIf="currentCost?.invalid && (currentCost?.touched || submitted)">
                  <div *ngIf="currentCost?.errors?.['min']">Custo deve ser maior ou igual a 0</div>
                </div>
              </div>
            </div>

            <!-- Margem de Lucro -->
            <div class="col-md-4">
              <div class="form-group">
                <label for="profitMarginPercentage">Margem de Lucro (%)</label>
                <input 
                  type="number" 
                  id="profitMarginPercentage" 
                  formControlName="profitMarginPercentage" 
                  class="form-control"
                  [class.is-invalid]="profitMarginPercentage?.invalid && (profitMarginPercentage?.touched || submitted)"
                  step="0.01"
                  min="0"
                  max="999.99"
                  placeholder="0.00">
                <small class="form-text text-muted">
                  Margem de lucro sobre o custo
                </small>
                <div class="invalid-feedback" *ngIf="profitMarginPercentage?.invalid && (profitMarginPercentage?.touched || submitted)">
                  <div *ngIf="profitMarginPercentage?.errors?.['min']">Margem deve ser maior ou igual a 0</div>
                  <div *ngIf="profitMarginPercentage?.errors?.['max']">Margem deve ser menor que 1000%</div>
                </div>
              </div>
            </div>
          </div>

          <!-- Botões -->
          <div class="form-actions-side">
            <!-- Botão Principal de Salvar -->
            <button
              type="submit"
              class="btn btn-primary"
              [disabled]="loading">
              <i class="fas fa-save"></i>
              {{ loading ? 'Salvando...' : 'Salvar Serviço' }}
            </button>

            
            <button 
              type="button" 
              class="btn btn-secondary" 
              (click)="cancel()"
              [disabled]="loading">
              <i class="fas fa-times"></i> Cancelar
            </button>
          </div>
        </div>
      </div>

      <!-- Coluna Direita -->
      <div class="col-md-4">
        <!-- Preview Card -->
        <div class="preview-card">
          <h4><i class="fas fa-calculator"></i> Resumo do Serviço</h4>

          <!-- Informações Básicas -->
          <div class="info-section mb-3">
            <div class="preview-item">
              <span class="preview-label">Nome:</span>
              <span class="preview-value">{{ name?.value || '-' }}</span>
            </div>

            <div class="preview-item">
              <span class="preview-label">Código:</span>
              <span class="preview-value">{{ code?.value || '-' }}</span>
            </div>

            <div class="preview-item">
              <span class="preview-label">Categoria:</span>
              <span class="preview-value">
                {{ form.get('category')?.value || '-' }}
              </span>
            </div>

            <div class="preview-item">
              <span class="preview-label">Tempo estimado:</span>
              <span class="preview-value">{{ formatTimePreview() }}</span>
            </div>
          </div>

          <!-- Grid de Preços -->
          <div class="pricing-grid">
            <div class="pricing-item">
              <span class="pricing-label">Custo Base</span>
              <span class="pricing-value">
                {{ baseCost?.value ? (baseCost?.value | currency:'BRL':'symbol':'1.2-2') : '-' }}
              </span>
            </div>

            <div class="pricing-item">
              <span class="pricing-label">Custo Atual</span>
              <span class="pricing-value">
                {{ currentCost?.value ? (currentCost?.value | currency:'BRL':'symbol':'1.2-2') : '-' }}
              </span>
            </div>

            <div class="pricing-item">
              <span class="pricing-label">Margem</span>
              <span class="pricing-value">
                {{ profitMarginPercentage?.value ? profitMarginPercentage?.value + '%' : '-' }}
              </span>
            </div>

            <div class="pricing-item pricing-final">
              <span class="pricing-label">Preço Final</span>
              <span class="pricing-value">
                {{ calculatePreview() | currency:'BRL':'symbol':'1.2-2' }}
              </span>
            </div>
          </div>

          <div class="form-group mt-4">
            <label for="status">Status <span class="required">*</span></label>
            <select
              id="status"
              formControlName="status"
              class="form-control"
              [class.is-invalid]="form.get('status')?.invalid && (form.get('status')?.touched || submitted)">
              <option value="">Selecione um status...</option>
              <option *ngFor="let status of statuses" [value]="status.name">
                {{ status.name }}
              </option>
            </select>
            <div class="invalid-feedback" *ngIf="form.get('status')?.invalid && (form.get('status')?.touched || submitted)">
              Status é obrigatório
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
  </div>
</app-side-menu>

